import { render } from "./DkBotMessages.vue?vue&type=template&id=438f04a2"
import script from "./DkBotMessages.vue?vue&type=script&lang=js"
export * from "./DkBotMessages.vue?vue&type=script&lang=js"

import "./DkBotMessages.vue?vue&type=style&index=0&id=438f04a2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__